export const AUTH0_ORG_PREFIX = 'org_'

export const NO_REDIRECT_ROUTE = '#'

export const constructUrlWithOrgId = ({
  orgId,
  url
}: {
  orgId: string
  url: Record<string, any> | string
}) => {
  if (!url || typeof orgId !== 'string') return url

  const isExternalUrl =
    typeof url === 'string' &&
    ['http://', 'https://'].find((prefix) => (url as string).startsWith(prefix))

  if (isExternalUrl) return url

  if (typeof url === 'string') {
    if (
      url === '/' ||
      url === NO_REDIRECT_ROUTE ||
      url.startsWith(`/${AUTH0_ORG_PREFIX}`)
    )
      return url

    const urlWithOrgId = `/${orgId}${url}`

    url = urlWithOrgId
  } else {
    if (url.pathname === '/') return url
    if (url.pathname.includes('[providerOrganizationId]')) {
      url = {
        ...url,
        pathname: url.pathname,
        query: {
          ...(url.query as Record<string, any>),
          providerOrganizationId: orgId
        }
      }
    } else {
      const urlWithOrgId = `/[providerOrganizationId]${url.pathname}`

      url = {
        ...url,
        pathname: urlWithOrgId,
        query: {
          ...(url.query as Record<string, any>),
          providerOrganizationId: orgId
        }
      }
    }
  }

  return url
}

export const handleOrganizationRoutes = ({
  orgId,
  pathname,
  switchOrganizationPath
}: {
  orgId: string
  pathname: string
  switchOrganizationPath: string
}) => {
  if (!orgId) return

  const pathnameOrg = pathname.split('?')[0].split('/')[1]

  if (!pathnameOrg.includes(AUTH0_ORG_PREFIX) && orgId) {
    //redirect to same route, but prepend organizationId
    return `/${orgId}${pathname}`
  }

  if (orgId === pathnameOrg && pathname.includes(switchOrganizationPath)) {
    return '/'
  }

  if (
    orgId &&
    orgId !== pathnameOrg &&
    !pathname.includes(switchOrganizationPath)
  ) {
    return `/${pathnameOrg}${switchOrganizationPath}?callbackUrl=${
      location.origin + pathname
    }`
  }
}
